import { render, staticRenderFns } from "./ClientDetailsPublic.vue?vue&type=template&id=88b38e38&"
import script from "./ClientDetailsPublic.vue?vue&type=script&lang=js&"
export * from "./ClientDetailsPublic.vue?vue&type=script&lang=js&"
import style0 from "./ClientDetailsPublic.vue?vue&type=style&index=0&id=88b38e38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports